"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isoDays_1 = __importDefault(require("./isoDays"));
const isoDayKanji = Object.freeze({
    [isoDays_1.default.MON]: "月",
    [isoDays_1.default.TUE]: "火",
    [isoDays_1.default.WED]: "水",
    [isoDays_1.default.THUR]: "木",
    [isoDays_1.default.FRI]: "金",
    [isoDays_1.default.SAT]: "土",
    [isoDays_1.default.SUN]: "日",
});
exports.default = isoDayKanji;
